var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarathonLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;fill:none;}\n\t.st2{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000018214892307458776060000014093358970950366863_",
    className: "st0"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    width: 72,
    height: 72
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000075847225059929143080000016703665826754847649_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M36.1,1.2C16.7,1.2,0.9,16.9,0.9,36.3c0,17.9,13.4,32.6,30.6,34.8V49.1C21.6,47,14.1,38.1,14.1,27.6 c0-12.2,9.9-22,22-22c12.2,0,22,9.9,22,22c0,10.5-7.5,19.4-17.5,21.5v22.1c17.2-2.2,30.6-17,30.6-34.8 C71.2,16.9,55.5,1.2,36.1,1.2z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarathonLogo);
export default __webpack_public_path__ + "static/media/marathon_logo.022c0c7af43e1c2c5c1b010d89f95d35.svg";
export { ForwardRef as ReactComponent };